import { t } from "i18next";
import { DTO, Types } from "shared-lib";
import { RideFilterEnum } from "./api.types";
import {
  DriverTableAction,
  DriverTableData,
  DriverTableFullName,
} from "./driver-table.types";

export type OpenAIModel = Types.OpenAIModelEnum;

export type ChatBody = {
  inputCode: string;
  model: OpenAIModel;
  apiKey?: string | undefined;
};

export type LoaderProps = {
  size?: number;
};

export type RowObj = DriverTableData;

export type CustomFieldType1 = DriverTableFullName;

export type CustomFieldType2 = DriverTableAction;

export type SelectOption = {
  value: string;
  label: string;
};

export type RideStatusOption = {
  value: RideFilterEnum;
  label: string;
};

export type TableValue = string | number | boolean | null | undefined | TableValueMap;
export type TableValueMap = { [key: string]: TableValue };

export type FormFieldValue =
  | string
  | number
  | boolean
  | null
  | undefined
  | TableValueMap
  | TableValue[]
  | File;

export type FormValues = { [key: string]: FormFieldValue };

export type DriverStatus = Types.ApprovalStatus;

export type profImage = {
  key: string;
  url: string;
  file?: File;
};

export type FinalDocArray = {
  key: string;
  url?: string;
  file?: File;
};

export type VehicleFormLoggerProps = {
  setIsDocuments: (val: boolean) => void;
  display?: string;
  allAvailableVehiclesTypes?: DTO.CategoryDTO[];
};

export type formvalues = {
  firstName: string;
  lastName: string;
  mobileNumber: string;
  email: string;
  address: string;
  vehicleNumber: string;
  vehicleType: string;
  vehicleModel: string;
  vehicleMake: string;
  vehicleName: string;
  profileImageKey: string;
  documentsKey: string[];
  addressDocumentKey: string[];
  documentsCriminalsKey?: string[];
  image?: File[];
  documents?: File[];
};
export const statusOptions: RideStatusOption[] = [
  { value: RideFilterEnum.ALL, label: t("All Rides") },
  { value: RideFilterEnum.CURRENT_RIDES, label: t("Ongoing Rides") },
  { value: RideFilterEnum.COMPLETED, label: t("Completed Rides") },
  { value: RideFilterEnum.CANCELLED, label: t("Cancelled Rides") },
  { value: RideFilterEnum.HAS_DISPUTE, label: t("With Dispute") },
];
